import {Component, inject, OnInit, signal, ViewChild} from '@angular/core';
import {DialogBaseComponent} from "../../dialogs/dialog-base/dialog-base.component";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {IFaqGameAssociationDialogData} from "../../../interfaces/IFaqGameAssociationDialogData";
import {IFrequentlyAskedQuestions} from "../../../interfaces/IFrequentlyAskedQuestions";
import {MatButton} from "@angular/material/button";
import {FrequentlyAskedQuestionsService} from "../../../services/frequently-asked-questions.service";
import {IEditFrequentlyAskedQuestions} from "../../../interfaces/IEditFrequentlyAskedQuestions";
import {SnackbarService} from "../../../services/snackbar.service";
import {MatIcon} from "@angular/material/icon";
import {FaqGameSelectorComponent} from "../faq-game-selector/faq-game-selector.component";

@Component({
  selector: 'app-faq-game-association-dialog',
  standalone: true,
  imports: [
    DialogBaseComponent,
    MatButton,
    MatIcon,
    FaqGameSelectorComponent
  ],
  templateUrl: './faq-game-association-dialog.component.html',
  styleUrl: './faq-game-association-dialog.component.css'
})
export class FaqGameAssociationDialogComponent implements OnInit {
  private matDialogRef = inject(MatDialogRef<FaqGameAssociationDialogComponent>);
  private dialogData = inject<IFaqGameAssociationDialogData>(MAT_DIALOG_DATA);
  private faqService = inject(FrequentlyAskedQuestionsService);
  private snackbarService = inject(SnackbarService);

  @ViewChild(FaqGameSelectorComponent) gameSelector!: FaqGameSelectorComponent;

  public faq!: IFrequentlyAskedQuestions;
  public isConvertingToGameSpecific: boolean = false;
  public isLoading = signal(false);
  public initialSelectedGameIds: string[] = [];

  ngOnInit(): void {
    this.faq = this.dialogData.faq;
    this.isConvertingToGameSpecific = this.dialogData.convertToGameSpecific || false;
    this.initialSelectedGameIds = this.faq.GameIds || [];
  }

  onSave(): void {
    const selectedGameIds = this.gameSelector?.getSelectedGameIds() ?? [];

    if (selectedGameIds.length === 0 && this.isConvertingToGameSpecific) {
      this.snackbarService.openErrorSnackBar('Please select at least one game');
      return;
    }

    this.isLoading.set(true);

    const command: IEditFrequentlyAskedQuestions = {
      id: this.faq.Id,
      question: this.faq.Question,
      answer: this.faq.Answer,
      active: this.faq.Active,
      ScopeType: this.faq.ScopeType,
      shared: false,
      gameIds: selectedGameIds
    };

    const editMethod = this.faq.ScopeType === 1
      ? this.faqService.editWebappFaq(command)
      : this.faqService.editAdminAppFaq(command);

    editMethod.subscribe({
      next: () => {
        const message = this.isConvertingToGameSpecific
          ? 'FAQ converted to game-specific successfully'
          : 'Game associations updated successfully';
        this.snackbarService.openSuccessfulSnackBar(message);
        this.matDialogRef.close(true);
      },
      error: (err) => {
        this.snackbarService.openErrorSnackBar('Failed to update FAQ: ' + err.message);
        this.isLoading.set(false);
      }
    });
  }
}
